/**
 * Enum per i sistemi di integrazione
 * Corrisponde al IntegrationSystemEnum del backend
 * Utilizzato da tutte le entità che hanno integrazioni (Customer, ProfitCenter, PurchaseOrder, ecc.)
 */
export enum IntegrationSystemEnum {
	// TODO: Aggiungere i valori corretti dall'enum backend
	BusinessCentral = 'BusinessCentral',
	MyInfinityPortal = 'MyInfinityPortal',
	// Aggiungere altri sistemi secondo necessità
}
